import { useUserInfoStore } from '@/store/modules/userInfo'

export const getToken = (online = false) => {
  if (online) {
    return useUserInfoStore().remoteToken
  }
  return useUserInfoStore().token
  // return getStoreToken(online)
}

export const setToken = (token: string, online = false) => {
  if (online) {
    useUserInfoStore().setRemoteToken(token)
  } else {
    useUserInfoStore().token = token
  }
  // setLocalToken(token, online)
}

export const isOnline = () => {
  return useUserInfoStore().isRemoteUser
}
